import { ManagePermissionGraph, PERMISSION, StandalonePermissions } from "@app/modules/roles/constants";

export function mapPermissions(global: PERMISSION[], pickingpoint: PERMISSION[], retailer: PERMISSION[]) {
  const ps = Array.from(
    new Set(
      [...global, ...pickingpoint, ...retailer].flatMap(p => {
        const find = ManagePermissionGraph[p];
        if (find) {
          return mapPermissions(find, [], []);
        } else {
          const single = [p];
          const prerequisite = StandalonePermissions[p];
          if (prerequisite) {
            single.push(prerequisite);
          }
          return [p];
        }
      })
    )
  );
  return ps;
}
